module.exports = __webpack_public_path__ + "h5/img/icon_3.fc34fcb9.png";